<script setup lang="ts">
import IconPilarTransparent from '~icons/pilar/pilar-transparent.svg';

defineProps<{
	title: string;
	description: string;
}>();
</script>

<template>
	<header class="relative h-[90dvh]">
		<div class="absolute inset-0">
			<span
				class="absolute inset-0 z-10 bg-[linear-gradient(0deg,rgba(0,0,0,0.2)_0%,rgba(0,0,0,0.2)_100%),linear-gradient(180deg,rgba(0,0,0,0.4)_0%,rgba(0,0,0,0)_50%,rgba(0,0,0,0.6)_100%)]"
			/>
			<NuxtImg
				loading="lazy"
				:src="'/images/about/about_background.webp'"
				alt="Pilar"
				width="1920"
				height="1080"
				sizes="xs:375px sm:640px md:768px lg:1024px xl:1280px 2xl:1920px"
				densities="x1"
				format="webp"
				quality="80"
				preload
				class="size-full object-cover"
				fetchpriority="high"
				decoding="async"
			/>
		</div>
		<Container
			class="absolute inset-x-0 z-20 flex h-full flex-col justify-end pb-9 md:pb-12"
		>
			<div class="flex flex-col-reverse justify-between gap-9 md:flex-row">
				<div class="flex max-w-[600px] flex-col items-start gap-3 md:gap-5">
					<h1
						class="text-center font-matter-sq text-[32px] font-normal leading-[150%] tracking-[-0.64px] text-white md:text-5xl md:leading-[110%] md:tracking-[-0.96px]"
					>
						{{ title }}
					</h1>
					<p class="text-base font-normal leading-[150%] text-white md:text-xl">
						{{ description }}
					</p>
				</div>
				<IconPilarTransparent
					class="h-9 w-11 stroke-white stroke-1 text-white md:h-24 md:w-20"
				/>
			</div>
		</Container>
	</header>
</template>
